<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
    <div>
      <a-form class="flex-form" :form="modal.form" :colon="false">
        <a-input v-decorator="['infoType']" style="display:none"></a-input>
        <a-form-item label="名称" required :labelCol="{ style: 'width:90px' }">
          <a-input
            v-decorator="[
              'infoName',
              {
                rules: [{ required: true, message: '名称不能为空' }],
              }]"
            placeholder="请输入名称"
          ></a-input>
        </a-form-item>
        <a-form-item label="语种" required :labelCol="{ style: 'width:90px' }">
          <!-- 多选 -->
          <a-select
            :dropdownMatchSelectWidth="false"
            class="form-control"
            style="width:100%"
            v-decorator="[
              'infoLanguage',
              {
                rules: [{ required: true, message: '语种不能为空' }],
              }
            ]"
            placeholder="请选择语种"
            mode="multiple"
          >
            <a-select-option v-for="(item, index) in languagesList" :key="index" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="加急" required :labelCol="{ style: 'width:90px' }">
          <a-select
            class="w-full"
            v-decorator="[
              'infoSpeed',
              {
                rules: [{ required: true, message: '加急类型不能为空' }],
              }
            ]"
            placeholder="请选择加急类型"
            allowClear
            :options="urgentList"
          ></a-select>
        </a-form-item>
        <a-form-item v-if="modal.type === 4" label="学历" required :labelCol="{ style: 'width:90px' }">
          <a-select
            class="w-full"
            v-decorator="[
              'infoEducation',
              {
                rules: [{ required: true, message: '学历不能为空' }],
              }]"
            placeholder="请选择学历"
            allowClear
            :options="educationList"
          ></a-select>
        </a-form-item>
        <a-form-item label="价格" required :labelCol="{ style: 'width:90px' }">
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="[
              'infoPrice',
              {
                rules: [{ required: true, message: '价格不能为空' }],
              }]"
            placeholder="请输入价格"
          ></a-input-number>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    return {
      languagesList: [
        {
          label: '大语种',
          value: '大语种',
        },
        {
          label: '小语种',
          value: '小语种',
        },
        {
          label: '英语',
          value: '英语',
        },
      ],
      urgentList: [
        {
          label: '普通',
          value: 0,
        },
        {
          label: '加急',
          value: 1,
        },
        {
          label: '特急',
          value: 2,
        },
      ],
      educationList: [
        {
          label: '中学',
          value: '中学',
        },
        {
          label: '大专',
          value: '大专',
        },
        {
          label: '本科及以上',
          value: '本科及以上',
        },
      ],
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '-',
        data: {},
      },
    }
  },
  mounted() {
  },
  methods: {
    getLanguagesList() {
      this.$axios.get('/additional/admin/dictionary/queryByParentKey?parentKey=YUZHONG').then(res => {
        this.languagesList = res.data.map(item => {
          return {
            label: item.dictionaryName,
            value: item.dictionaryKey,
          }
        })
      })
    },
    async start(obj, row) {
      this.getLanguagesList()
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = `${obj.name}`
      this.modal.type = obj.type ? obj.type : ''
      this.modal.data = {
        ...row,
      }
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      return new Promise((resolve, reject) => {
        this.$once('end', function (state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            resolve()
            // reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            if (this.modal.type) {
              params['infoType'] = this.modal.type
            }
            this.modal.visible = false
            this.$emit('end', 'ok', params)
          } catch (e) {}
        }
      })
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
